<template>
  <v-navigation-drawer
    :value="value"
    right
    temporary
    fixed
    width="480"
    @input="$emit('input', $event)"
  >
    <div v-if="detail" class="pa-4">
      <h3 class="mb-2">Review activity</h3>
      <div class="mb-4">
        {{ detail.stageProgress.screenedCount }}/{{
          detail.stageProgress.totalReferences
        }}
        screened ·
        {{ detail.stageProgress.fullTextVotedCount }} full-text ·
        {{ detail.stageProgress.extractionReportCount }} extractions
      </div>
      <h4>By member</h4>
      <v-simple-table dense>
        <thead>
          <tr>
            <th>Member</th>
            <th>Screen</th>
            <th>FT</th>
            <th>Comments</th>
            <th>Extractions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="m in detail.memberBreakdown"
            :key="m.researcherId"
          >
            <td>{{ m.email }}</td>
            <td>{{ m.screeningVotes }}</td>
            <td>{{ m.fullTextVotes }}</td>
            <td>{{ m.comments }}</td>
            <td>{{ m.extractionReports }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <h4 class="mt-4">Recent jobs</h4>
      <div
        v-for="(j, i) in detail.recentJobs"
        :key="i"
        class="text-caption"
      >
        {{ j.jobType }} — {{ j.state }} ({{ j.createdAt }})
      </div>
    </div>
    <div v-else class="pa-4">Loading…</div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'ReviewActivityDetailPanel',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    reviewId: {
      type: String,
      default: null,
    },
  },
  emits: ['input'],
  data: () => ({
    detail: null,
  }),
  watch: {
    async reviewId(id) {
      this.detail = null;
      if (id) {
        this.detail = await this.$store.dispatch(
          'adminActivity/fetchReviewDetail',
          id
        );
      }
    },
  },
};
</script>
